import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ShipmentSpecialFreightItemState } from './shipment-special-freight-item.state';
import { Store } from '@ngxs/store';
import {
  ShipmentSpecialFreightItemNotificationListCountLoad,
  ShipmentSpecialFreightItemSetIdentifier,
  ShipmentSpecialFreightItemSetInitial,
} from './shipment-special-freight-item.actions';
import { SpecialFreightIdView } from '../../../models';

@Injectable({ providedIn: 'root' })
export class ShipmentSpecialFreightItemFacade {
  specialFreightIdentifier$: Observable<SpecialFreightIdView> = this.store.select(
    ShipmentSpecialFreightItemState.getSpecialFreightIdentifier,
  );

  notificationListCount$: Observable<number> = this.store.select(
    ShipmentSpecialFreightItemState.getSpecialFreightNotificationListCount,
  );

  loaded$: Observable<boolean> = this.store.select(ShipmentSpecialFreightItemState.getLoaded);

  constructor(private store: Store) {}

  setShipmentSpecialFreightIdentifier(identifier: SpecialFreightIdView): void {
    this.store.dispatch(new ShipmentSpecialFreightItemSetIdentifier(identifier));
  }

  loadShipmentSpecialFreightNotificationListCount(identifier: SpecialFreightIdView): void {
    this.store.dispatch(new ShipmentSpecialFreightItemNotificationListCountLoad(identifier));
  }

  setInitialState(): void {
    this.store.dispatch(new ShipmentSpecialFreightItemSetInitial());
  }
}
